export class MonitoringCriteriaItemModel {
    name: string;
    id: any;

    constructor(name: string, id: any) {
        this.name = name;
        this.id = id;
    }
}
